import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Recevez un lien de réinitialisation par email."
      footer={
        <Link to="/login" className="text-[#C4553B] hover:underline" data-testid="link-back-login">
          Retour à la connexion
        </Link>
      }
    >
      {done ? (
        <div
          className="flex items-start gap-3 rounded-lg border border-emerald-500/30 bg-emerald-500/10 p-4 text-sm text-emerald-100"
          data-testid="forgot-success"
        >
          <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0" />
          <div>
            Si un compte existe pour cet email, un lien de réinitialisation vient d&apos;y être
            envoyé.
            <p className="mt-2 text-xs text-emerald-200/80">
              (Si vous n&apos;avez rien reçu, vérifiez avec votre administrateur — l&apos;envoi peut être en mode test.)
            </p>
          </div>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label className="text-slate-300">Email</Label>
            <Input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-slate-700 bg-slate-950/40 text-slate-100"
              data-testid="forgot-email-input"
            />
          </div>
          {error && (
            <div className="rounded border border-red-500/30 bg-red-500/10 p-2.5 text-sm text-red-300">
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C4553B] text-white hover:bg-[#A8402C]"
            data-testid="forgot-submit-btn"
          >
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            Envoyer le lien
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
